import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = {
    key: 0,
    class: "widget_container_box"
};
const _hoisted_4 = {
    key: 1,
    class: "widget_container_overlay_sticker"
};
const _hoisted_5 = {
    key: 2,
    class: "widget_container_combi_badge"
};
import { onMounted } from 'vue';
const externalJsSrc = 'https://cdn.trustami.com/widgetapi/widget2/trustami-widget.js';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TrustamiWidget',
    props: {
        appearance: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        const loadExternalJs = () => {
            if (document.querySelector(`script[src="${externalJsSrc}"]`)) {
                // already loaded
                return;
            }
            const script = document.createElement('script');
            script.src = externalJsSrc;
            script.async = true;
            script.type = 'text/javascript';
            script.setAttribute('data-platform', '0');
            script.setAttribute('data-user', '21f1cf8cbb78845f6c25aa814574ad0554dee1e0');
            script.setAttribute('data-profile', '56dd400ccc96c5340c8b4575');
            script.id = 'trustamiwidget';
            document.body.appendChild(script);
        };
        onMounted(() => {
            loadExternalJs();
        });
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (props.appearance === 'big')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                        : _createCommentVNode("", true),
                    (props.appearance === 'medium')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                        : _createCommentVNode("", true),
                    (props.appearance === 'small')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
